export enum NavigationItems {
  Statistics = 50,
  Dashboard = 75,
  PlannerCalendar = 100,
  CardRefill = 200,

  // Administration
  Users = 300,
  Plans = 400,
  Families = 450,
  Employees = 500,
  PlanTypes = 550,
  ServiceTypes = 560,
  EventTypeCategories = 565,
  BreakTypes = 570,
  Halls = 580,
  Studios = 600,
  Tenants = 700,
  StudioRelations = 750,
  CommunicationLogs = 760,
  Invoices = 770,
  Forms = 775,
  GiftVouchers = 778,
  StudioReviews = 777,

  // Cashdesk
  Cashdesk = 150,

  // Gym
  Gym = 160,

  // Inventory
  InventoryOverview = 779,
  InventoryProducts = 780,
  InventoryTransfers = 781,

  // Portal
  PortalCalendar = 900,
  MyReservations = 1000,
  MyFamily = 1100,
  MyPlans = 1200,
  MyWorkouts = 1250,
  MyBodyMetrics = 1275,
  MyGoals = 1280,
  MyConsents = 1300,

  // Support
  Support = 1500,

  //Logout
  Login = 800,
  Logout = 800,
}
